// Los comunicados: un correo de la Academia a todas sus cuentas, que solo manda Gabri.
//
// NINGUNA DE ESTAS LLAMADAS SE HACE SOLA. Las hace la pantalla de Comunicados cuando la cuenta
// de administracion pulsa un botón, y `enviaComunicado` lleva además cuántas personas vio en la
// pantalla al confirmar: si ya no son esas, el servidor no manda nada y dice cuántas son. El
// porqué entero, en `backend/app/domain/comunicado.py`.
import { api } from "./client";

export const traeComunicados = () => api.get("/admin/comunicados").then((r) => r.data);

export const vistaPreviaDelComunicado = (asunto, cuerpo) =>
  api.post("/admin/comunicados/vista-previa", { asunto, cuerpo }).then((r) => r.data);

export const pruebaDelComunicado = (asunto, cuerpo) =>
  api.post("/admin/comunicados/prueba", { asunto, cuerpo }).then((r) => r.data);

export const enviaComunicado = ({ asunto, cuerpo, audiencia, confirmo }) =>
  api.post("/admin/comunicados", { asunto, cuerpo, audiencia, confirmo }).then((r) => r.data);

export const continuaComunicado = (id) =>
  api.post(`/admin/comunicados/${encodeURIComponent(id)}/continuar`).then((r) => r.data);

export const estadoDelComunicado = (id) =>
  api.get(`/admin/comunicados/${encodeURIComponent(id)}`).then((r) => r.data);
